import React from 'react';
import {Col, Form, InputGroup, Row} from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar} from "@fortawesome/free-solid-svg-icons";
import SelectInputField from "../../components/inputs/SelectInputField";
import {dateToString, dateWithMaxTime, dateWithZeroTime} from "../../tools";
import {RRTruckType} from "../../types/RRTruckType";

export interface Filters {
    periodFrom: Date | undefined;
    periodTo: Date | undefined;
    driverId: string;
    truckId: string;
}

interface Props {
    filters: Filters;
    setFilters: React.Dispatch<React.SetStateAction<Filters>>;
    sortedTrucks: RRTruckType[];
    filteredEmployees: any[];
    loadingTrucks?: boolean;
    onAdd: () => void;
    onPrint: () => void;
    onExport: () => void;
}

export const FuelInvoicesFilter: React.FC<Props> = ({filters, setFilters, sortedTrucks, filteredEmployees, onAdd, onPrint, onExport}) => {
    return (
        <Form className="mb-3">
            <Row className="align-items-end g-2">
                <Col xs={"auto"}>
                    <Form.Label>От дата</Form.Label>
                    <InputGroup className="mb-2 w-160px flex-nowrap">
                        <ReactDatePicker
                            id={"fuelFromDate"}
                            wrapperClassName={"w-100px"}
                            selected={filters.periodFrom}
                            onChange={(date) => setFilters({...filters, periodFrom: dateWithZeroTime(date || new Date())!})}
                            className="form-control flex-nowrap"
                            dateFormat="dd.MM.yyyy"
                            value={dateToString(filters.periodFrom)}
                        />
                        <label htmlFor={"fuelFromDate"}>
                            <InputGroup.Text className={"lh-2-5em"}>
                                <FontAwesomeIcon icon={faCalendar} />
                            </InputGroup.Text>
                        </label>
                    </InputGroup>
                </Col>

                <Col xs={"auto"}>
                    <Form.Label>До дата</Form.Label>
                    <InputGroup className="mb-2 w-160px flex-nowrap">
                        <ReactDatePicker
                            id={"fuelToDate"}
                            wrapperClassName={"w-100px"}
                            selected={filters.periodTo}
                            onChange={(date) => setFilters({...filters, periodTo: dateWithMaxTime(date || new Date())!})}
                            className="form-control flex-nowrap"
                            dateFormat="dd.MM.yyyy"
                            value={dateToString(filters.periodTo)}
                        />
                        <label htmlFor={"fuelToDate"}>
                            <InputGroup.Text className={"lh-2-5em"}>
                                <FontAwesomeIcon icon={faCalendar} />
                            </InputGroup.Text>
                        </label>
                    </InputGroup>
                </Col>

                <Col xs={"auto"}>
                    <SelectInputField
                        label="Превозно средство"
                        value={filters.truckId}
                        onChange={(value) => setFilters({...filters, truckId: value || ""})}
                        options={[{value: "", label: "Всички"}, ...(sortedTrucks || []).map((t: RRTruckType) => ({value: t.id, label: `${t.name}${t.plate ? ' (' + t.plate + ')' : ''}`}))]}
                    />
                </Col>

                <Col xs={"auto"}>
                    <SelectInputField
                        label="Шофьор"
                        value={filters.driverId}
                        onChange={(value) => setFilters({...filters, driverId: value || ""})}
                        options={[{value: "", label: "Всички"}, ...filteredEmployees.map(e => ({value: e.id, label: e.name}))]}
                    />
                </Col>

                <Col className="d-flex align-items-end">
                    <div>
                        {/* Buttons moved to the main view (FuelInvoicesView) */}
                    </div>
                </Col>
            </Row>
        </Form>
    );
}

export default FuelInvoicesFilter;
